import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';
import { useNavigate } from 'react-router-dom';

import { v2Colors } from '../../design/theme';

export default function CheckoutPageHeader({ backTo = '/v2/cart', title = 'Checkout' }) {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
      <IconButton
        aria-label="Go back"
        onClick={() => navigate(backTo)}
        sx={{
          width: 40,
          height: 40,
          bgcolor: v2Colors.white,
          border: `1px solid ${v2Colors.primary}`,
          color: v2Colors.primary,
          '&:hover': { bgcolor: v2Colors.selectedFill },
        }}
      >
        <ArrowBackRounded fontSize="small" />
      </IconButton>
      <Typography
        component="h1"
        sx={{
          fontWeight: 700,
          fontSize: { xs: '1.65rem', sm: '1.85rem' },
          color: v2Colors.heading,
          lineHeight: 1.15,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}
